import React from "react";
import SignerActions from "../aadeSigners/SignerActions";

export const columns = [
  { field: "afm", headerName: "ΑΦΜ", width: 150 },
  { field: "first_name", headerName: "Όνομα", width: 130 },
  { field: "last_name", headerName: "Επώνυμο", width: 130 },
  {
    field: "actions",
    headerName: "",
    width: 130,
    renderCell: (params) => (
      <SignerActions
        row={params.row}
        deletedAfms={deletedAfms}
        signers={signers}
        setSigners={setSigners}
        setDeletedAfms={setDeletedAfms}
        setSelectedAfm={setSelectedAfm}
        setDeleteDialogOpen={setDeleteDialogOpen}
        setNotification={setNotification}
      />
    ),
  },
];
